var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row py-3 mb-4 border-bottom align-items-center" },
      [
        _c("div", { staticClass: "col" }, [
          _c("h1", { staticClass: "company-h1" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/companies")
                }
              }
            }),
            _vm._v("\n        Create Company\n      ")
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-5 company-created" }, [
      _c("div", { staticClass: "col-4 mx-auto align-middle text-center" }, [
        _c("img", {
          staticClass: "w-75",
          attrs: { src: require("../../assets/img/company-info.png") }
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("h4", [_vm._v("Company Created")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We created company but we need more info to finish onboarding"
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                _vm.setCompanyStep("companies-map")
              }
            }
          },
          [_vm._v("FINISH COMPANY SETUP")]
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-link",
            on: {
              click: function($event) {
                _vm.$router.push("/companies")
              }
            }
          },
          [_vm._v("Do it later")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f2a73f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2a73f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesCreated.vue
// module id = null
// module chunks = 